module.exports = __webpack_public_path__ + "img/hr-tree-06-f-trunk.1280a33e.png";